import apiClient from '../client';
import type { Vehicle, TransportRoute, StudentTransport } from '@/types';

const VEHICLES   = '/admin/vehicles';
const ROUTES     = '/admin/routes';
const STUDENTS   = '/admin/student-transport';

export const transportApi = {
  listVehicles: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Vehicle[]; pagination: { total: number } }>(VEHICLES, { params }).then((r) => r.data),

  getVehicle: (id: number) =>
    apiClient.get<{ data: Vehicle }>(`${VEHICLES}/${id}`).then((r) => r.data.data),

  createVehicle: (payload: Omit<Vehicle, 'id' | 'created_at'>) =>
    apiClient.post<{ data: Vehicle }>(VEHICLES, payload).then((r) => r.data.data),

  updateVehicle: (id: number, payload: Partial<Vehicle>) =>
    apiClient.put<{ data: Vehicle }>(`${VEHICLES}/${id}`, payload).then((r) => r.data.data),

  listRoutes: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: TransportRoute[]; pagination: { total: number } }>(ROUTES, { params }).then((r) => r.data),

  getRoute: (id: number) =>
    apiClient.get<{ data: TransportRoute }>(`${ROUTES}/${id}`).then((r) => r.data.data),

  createRoute: (payload: Omit<TransportRoute, 'id' | 'created_at' | 'vehicle'>) =>
    apiClient.post<{ data: TransportRoute }>(ROUTES, payload).then((r) => r.data.data),

  updateRoute: (id: number, payload: Partial<TransportRoute>) =>
    apiClient.put<{ data: TransportRoute }>(`${ROUTES}/${id}`, payload).then((r) => r.data.data),

  listStudentTransport: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: StudentTransport[]; pagination: { total: number } }>(STUDENTS, { params }).then((r) => r.data),

  assignStudent: (payload: Omit<StudentTransport, 'id' | 'student' | 'route'>) =>
    apiClient.post<{ data: StudentTransport }>(STUDENTS, payload).then((r) => r.data.data),
};

